export const GET_COUPONS_DETAIL = "admin/GET_COUPONS_DETAIL";
export const GET_COUPONS_DETAIL_SUCCESS = "admin/GET_COUPONS_DETAIL_SUCCESS";
export const GET_COUPONS_DETAIL_FAILURE = "admin/GET_COUPONS_DETAIL_FAILURE";
